<div #chart class="h-full w-full rounded-3xl">
  <lib-teeth
    [currentTeeth]="displayedTeeth()"
    [isSingleToothView]="true"
    [singleTooth]="tooth()"
    [drawCross]="false"
    [drawLabels]="drawLabels()"
    [isPerioHistoryView]="isPerioHistoryView()"
  ></lib-teeth>
</div>
